"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UILayout = require("./UILayout.js"),
    template = require("./ExternalLayout.html");
var ExternalLayout = function (_UILayout) {
  _inherits(ExternalLayout, _UILayout);

  function ExternalLayout() {
    _classCallCheck(this, ExternalLayout);

    return _possibleConstructorReturn(this, (ExternalLayout.__proto__ || Object.getPrototypeOf(ExternalLayout)).call(this, template));
  }

  return ExternalLayout;
}(UILayout);

module.exports = ExternalLayout;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkV4dGVybmFsTGF5b3V0LmpzIl0sIm5hbWVzIjpbIlVJTGF5b3V0IiwicmVxdWlyZSIsInRlbXBsYXRlIiwiRXh0ZXJuYWxMYXlvdXQiLCJbb2JqZWN0IE9iamVjdF0iLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUVBLElBQU1BLFdBQVdDLFFBQVEsZUFBUkEsQ0FBakI7QUFBQSxJQUNJQyxXQUFXRCxRQUFRLHVCQUFSQSxDQURmO0lBR01FLGM7OztBQUNGQyw0QkFBQUE7QUFBQUE7O0FBQUFBLDJIQUNVRixRQURWRTtBQUNVRjs7O0VBRmVGLFE7O0FBTTdCSyxPQUFPQyxPQUFQRCxHQUFpQkYsY0FBakJFIn0=